import React from 'react'
import SNavbar from '../Components/Square/SNavbar/SNavbar'
import SHeader from "../Components/Square/SHeader/SHeader"
import Residency from '../Components/Square/Residency/residency'
import PremiumResidences from "../Components/Square/PremiumResidences/Premiumresidences"
import ResidencePlan from "../Components/Square/ResidencePlan/ResidencePlan"
import Services from '../Components/Square/Services/Services'
import Amenities from '../Components/Square/Amenities/Amenities'
import Surrounding from '../Components/Square/Surrounding/Surrounding'
import Footer from '../Components/Square/Footer/Footer'

const Square = () => {
  return (  
    <>
      <SNavbar />
      <SHeader />
      <Residency />
      <PremiumResidences />
      <ResidencePlan />
      <Services />
      <Amenities />
      <Surrounding />
      <Footer />
    </>
  )
}

export default Square